export const ambToProcedure = amb => {
    switch (amb) {
        case '10001111': return '50000462' // Consulta em psicologia
        case '10001113': return '50000470' // Sessão de Psicoterapia Individual por Psicólogo
        default: return 'nenhum'
    }
}